module.exports = __webpack_public_path__ + "63f665d12a575912f7a2c97e51a2e056.svg";